import { Module } from 'vuex'

import { GetRecentJudgeResultListUseCase } from '@/application/judge/getRecentJudgeResultListUseCase'
import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'

interface RecentJudgeListState {
  recentJudgeList: JudgeRecord[]
  isLoading: boolean
  error: string | null
}

let isPushJudgeRecordsProcessing = false

export const recentJudgeListModule = (judgeRepository: JudgeRepository): Module<RecentJudgeListState, any> => {
  const getRecentJudgeResultListUseCase = new GetRecentJudgeResultListUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      recentJudgeList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setRecentJudgeList(state, { judgeList }: { judgeList: JudgeRecord[] }) {
        state.recentJudgeList = judgeList
      },
      async pushRecentJudgeList(state, { judgeRecord }: { judgeRecord: JudgeRecord }) {
        // judgeRecordが不明なら処理を終了
        if (judgeRecord == undefined) return
        if (judgeRecord.judgeId == undefined || judgeRecord.status == 'WAITING') return

        // この関数が実行中の場合は待機
        while (isPushJudgeRecordsProcessing) {
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
        isPushJudgeRecordsProcessing = true

        try {
          if (state.recentJudgeList.length > 100 && judgeRecord.status != 'RUNNING') {
            while (state.recentJudgeList.length > 100) {
              state.recentJudgeList.pop()
            }
          }
          // 最新のジャッジ結果と同じ場合は処理を終了
          if (
            state.recentJudgeList.length > 0 &&
            state.recentJudgeList[0].judgeId == judgeRecord.judgeId &&
            state.recentJudgeList[0].status == judgeRecord.status
          ) {
            return
          }
          state.recentJudgeList.unshift(judgeRecord)
        } finally {
          isPushJudgeRecordsProcessing = false
        }
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getRecentJudgeResultList({ commit }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const res = await getRecentJudgeResultListUseCase.getRecentJudgeResultList()
          commit('setRecentJudgeList', { judgeList: res })
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      recentJudgeList: state => state.recentJudgeList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
